/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ActivatedRoute, CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { LoggedInContextService } from '@well/shared-providers';

export const companyDetailsNotValidatedGuard: CanMatchFn = () => {
  const contextService = inject(LoggedInContextService);
  const router = inject(Router);
  const route = inject(ActivatedRoute);

  return contextService.userContext$.pipe(
    map((loggedInContext) => {
      if (!loggedInContext?.companyDetailsValidated) {
        return true;
      }
      const returnUrl: string = route.snapshot.queryParams['returnUrl'] || '/';
      router.navigate([returnUrl]);
      return false;
    })
  );
};
